import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { submitMentorApplication } from '../services/api';
import { toast } from 'sonner';

const ApplyMentorModal = ({ open, onOpenChange }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    company_email: '',
    mobile_number: '',
    designation: '',
    city: '',
    industry: '',
    years_of_experience: ''
  });

  const industries = [
    "Technology & IT",
    "AI & Data Science",
    "Marketing & Growth",
    "Sales & Revenue",
    "Finance & Accounting",
    "HR & Talent",
    "Operations & Supply Chain",
    "Healthcare & Life Sciences",
    "Manufacturing",
    "Retail & E-commerce",
    "Consulting",
    "Education",
    "Media & Entertainment",
    "Real Estate",
    "Others"
  ];

  const indianCities = [
    "Mumbai",
    "Delhi",
    "Bengaluru",
    "Hyderabad",
    "Chennai",
    "Kolkata",
    "Pune",
    "Ahmedabad",
    "Jaipur",
    "Surat",
    "Lucknow",
    "Kanpur",
    "Nagpur",
    "Indore",
    "Thane",
    "Bhopal",
    "Visakhapatnam",
    "Vadodara",
    "Gurgaon",
    "Noida",
    "Others"
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleIndustryChange = (value) => {
    setFormData({
      ...formData,
      industry: value
    });
  };

  const handleCityChange = (value) => {
    setFormData({
      ...formData,
      city: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submissionData = {
        ...formData,
        years_of_experience: parseInt(formData.years_of_experience)
      };

      const response = await submitMentorApplication(submissionData);
      toast.success(response.message);
      setFormData({
        name: '',
        company_email: '',
        mobile_number: '',
        designation: '',
        city: '',
        industry: '',
        years_of_experience: ''
      });
      onOpenChange(false);
    } catch (error) {
      toast.error(error.message || 'Failed to submit application');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle style={{color: '#012726'}}>Apply as a Mentor</DialogTitle>
          <DialogDescription>
            Join 250+ industry professionals already mentoring through EduSocial.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="name">Name *</Label>
            <Input
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Priya Sharma"
            />
          </div>

          <div>
            <Label htmlFor="company_email">Company Email ID *</Label>
            <Input
              id="company_email"
              name="company_email"
              type="email"
              value={formData.company_email}
              onChange={handleChange}
              required
              placeholder="priya.sharma@company.com"
            />
          </div>
          
          <div>
            <Label htmlFor="mobile_number">Mobile Number *</Label>
            <Input
              id="mobile_number"
              name="mobile_number"
              type="tel"
              value={formData.mobile_number}
              onChange={handleChange}
              required
              placeholder="+91-9876543210"
            />
          </div>

          <div>
            <Label htmlFor="designation">Designation *</Label>
            <Input
              id="designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              required
              placeholder="Senior Software Engineer"
            />
          </div>

          <div>
            <Label htmlFor="city">City *</Label>
            <Select value={formData.city} onValueChange={handleCityChange} required>
              <SelectTrigger>
                <SelectValue placeholder="Select your city" />
              </SelectTrigger>
              <SelectContent className="z-[100]">
                {indianCities.map((city) => (
                  <SelectItem key={city} value={city}>
                    {city}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="industry">Industry *</Label>
            <Select value={formData.industry} onValueChange={handleIndustryChange} required>
              <SelectTrigger>
                <SelectValue placeholder="Select your industry" />
              </SelectTrigger>
              <SelectContent className="z-[100]">
                {industries.map((industry) => (
                  <SelectItem key={industry} value={industry}>
                    {industry}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label htmlFor="years_of_experience">Years of Experience *</Label>
            <Input
              id="years_of_experience"
              name="years_of_experience"
              type="number"
              min="0"
              max="60"
              value={formData.years_of_experience}
              onChange={handleChange}
              required
              placeholder="8"
            />
          </div>

          <Button 
            type="submit" 
            className="w-full text-white"
            disabled={loading}
            style={{backgroundColor: '#33c375'}}
          >
            {loading ? 'Submitting...' : 'Submit Application'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ApplyMentorModal;
